__turbopack_context__.v({
  "brand": "StandardBanner-module__ZH7tKq__brand",
  "card": "StandardBanner-module__ZH7tKq__card",
  "copy": "StandardBanner-module__ZH7tKq__copy",
  "cta": "StandardBanner-module__ZH7tKq__cta",
  "description": "StandardBanner-module__ZH7tKq__description",
  "frame": "StandardBanner-module__ZH7tKq__frame",
  "label": "StandardBanner-module__ZH7tKq__label",
  "logo": "StandardBanner-module__ZH7tKq__logo",
  "media": "StandardBanner-module__ZH7tKq__media",
  "radar": "StandardBanner-module__ZH7tKq__radar",
  "title": "StandardBanner-module__ZH7tKq__title",
});
